import React from 'react';
import DOMPurify from 'dompurify';

const allowedTags = [
    'p', 'h3', 'h4', 'strong', 'em', 'small', 'ul', 'ol', 'li',
    'figure', 'figcaption', 'table', 'caption', 'thead', 'tbody',
    'tr', 'th', 'td', 'div', 'span',
    'svg', 'title', 'desc', 'g', 'rect', 'line', 'path', 'circle',
    'polyline', 'polygon', 'text'
];

const allowedAttributes = [
    'colspan', 'rowspan', 'scope', 'role', 'aria-label',
    'viewBox', 'width', 'height', 'preserveAspectRatio',
    'x', 'y', 'x1', 'y1', 'x2', 'y2', 'cx', 'cy', 'r', 'rx', 'ry',
    'd', 'points', 'fill', 'fill-opacity', 'stroke', 'stroke-width',
    'stroke-linecap', 'stroke-linejoin', 'transform', 'text-anchor',
    'font-size', 'font-weight', 'dominant-baseline'
];

const unsafeAttributeValue = /(?:javascript\s*:|data\s*:|https?\s*:|\/\/|url\s*\()/i;

export function sanitizeChatHtml(html) {
    if (typeof html !== 'string' || !html.trim()) {
        return '';
    }

    const sanitized = DOMPurify.sanitize(html, {
        ALLOWED_TAGS: allowedTags,
        ALLOWED_ATTR: allowedAttributes,
        ALLOW_ARIA_ATTR: true,
        ALLOW_DATA_ATTR: false
    });

    const template = document.createElement('template');
    template.innerHTML = sanitized;

    template.content.querySelectorAll('*').forEach(element => {
        Array.from(element.attributes).forEach(attribute => {
            if (unsafeAttributeValue.test(attribute.value)) {
                element.removeAttribute(attribute.name);
            }
        });
    });

    return template.innerHTML;
}

export function ChatRichContent({ html }) {
    const sanitizedHtml = sanitizeChatHtml(html);

    if (!sanitizedHtml) {
        return null;
    }

    return (
        <div
            className="orsero-chat-rich-content"
            dangerouslySetInnerHTML={{ __html: sanitizedHtml }}
        />
    );
}
